import { EmailSignatureCache, SignatureData } from "intake_shared/src/types";
import { Collection } from "intake_shared/src/enum";
import db from "../utils/firestore";

let emailSignatureCache: EmailSignatureCache = {};

export async function addNewEmailSignature(signature: SignatureData) {
    try {
        const signatureKey = signature.email;
        await db
            .collection(Collection.EMAIL_SIGNATURES)
            .doc(signatureKey)
            .set(signature);
    } catch (error) {
        console.error("Error fetching email signatures:", error);
        return {};
    }
}

export async function updateEmailSignatureCache(): Promise<EmailSignatureCache> {
    try {
        const emailDocs = await db.collection(Collection.EMAIL_SIGNATURES).get();

        if (!emailDocs.empty) {
            emailSignatureCache = emailDocs.docs.reduce((cache, doc) => {
                const data = doc.data() as SignatureData;
                cache[doc.id] = data;
                return cache;
            }, {} as EmailSignatureCache);
        } else {
            emailSignatureCache = {};
        }

        return emailSignatureCache;
    } catch (error) {
        console.error("Error fetching department data:", error);
        return {};
    }
}

export async function getEmailSignatures(): Promise<EmailSignatureCache> {
    if (Object.keys(emailSignatureCache).length > 0) {
        return emailSignatureCache;
    }
    let consentForms = await updateEmailSignatureCache();
    return consentForms || ({} as EmailSignatureCache);
}

export async function deleteEmailSignature(signatureEmail: string) {
    try {
        const signatureRef = db
            .collection(Collection.EMAIL_SIGNATURES)
            .doc(signatureEmail);
        await signatureRef.delete();
        return true;
    } catch (error) {
        console.error("An Error Occured:", error);
        return {};
    }
}
